"use client"
import React, {useCallback, useEffect, useState} from 'react';
import {HeartIcon} from "lucide-react";
import {Tooltip, TooltipTrigger, TooltipContent, TooltipProvider} from "@/components/ui/tooltip";
import {Button} from "@/components/ui/button";
import AddToWish from "@/http/api/profile/wish/addToWish";
import {SingleProductEnum} from "@/constants/commerce-enum";
import {useAuthStore} from "@/store/auth/authStore";
import WizardFormAuth from "@/components/global/modals/wizard-auth-form-modal";
import {DataLayerFactory} from "@/components/google-tag-manager/DataLayerFactory";

const {getWish, isWish, removeWish} = new AddToWish();

const ProductWish = ({id, unique_id, title, price}: {
    id: string,
    unique_id: string,
    title: string,
    price: number | string
}) => {
    const [checkWish, setCheckWish] = useState<boolean | null>(null);
    const {token} = useAuthStore((state) => state);
    const fetchProductWish = useCallback(async () => {
        try {
            if (token) {
                const data: any = await isWish(unique_id);
                setCheckWish(data?.data?.isWish || false);
                DataLayerFactory.make('add_to_wishlist', null, null, null, null, null, {
                    unique_id,
                    title,
                    price,
                } as any);
            }
        } catch (error) {
            console.error("Error fetching wish status:", error);
        }
    }, [unique_id]);

    const addToWishHandler = async () => {
        try {
            if (checkWish) {
                await removeWish({model: "product", model_id: id});
            } else {
                await getWish({model: "product", model_id: id});
            }
            setCheckWish((prev) => !prev);
        } catch (error) {
            console.error("Error updating wish status:", error);
        }
    };

    useEffect(() => {
        if (unique_id) {
            fetchProductWish();
        }
    }, [unique_id, fetchProductWish]);

    if (token) {
        return (
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            variant={"default"}
                            className={"bg-lite-gray md:bg-gray-100 hover:bg-gray-200 shadow-none gray-background w-[48px] p-3 h-[48px] rounded-2xl"}
                            onClick={() => addToWishHandler()}
                        >
                            <HeartIcon className={`w-5 h-5 text-orange-primary`}
                                       fill={checkWish === true ? "#FF7745" : "transparent"}/>
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        <p>{
                            checkWish === false ? `${SingleProductEnum?.addToWish}` : `${SingleProductEnum.removeFromWish}`
                        }</p>
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        )
    } else {
        return (
            <WizardFormAuth customButton={
                <Button
                    variant={"default"}
                    className={"bg-lite-gray md:bg-gray-100 hover:bg-gray-200 shadow-none gray-background w-[48px] p-3 h-[48px] rounded-2xl"}
                >
                    <HeartIcon className={`w-5 h-5 text-orange-primary`}/>
                </Button>
            }/>
        )
    }


};

export default ProductWish;